import {BaseFormModel} from './base-form-model';
import {MenuModifier} from './menu-modifier';

export class MenuItemModifierSelectionOption extends BaseFormModel<MenuItemModifierSelectionOption> {
    id: number;
    menuModifier: MenuModifier;
    additionalPrice: number;
}
